/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Partial_TRegisterTalentManagerRequest_ } from '../models/Partial_TRegisterTalentManagerRequest_';
import type { TCreateTalentManagerReviewRequest } from '../models/TCreateTalentManagerReviewRequest';
import type { TGetTalentManagerProfileResponse } from '../models/TGetTalentManagerProfileResponse';
import type { TListTalentManagerProfilesResponse } from '../models/TListTalentManagerProfilesResponse';
import type { TListTalentManagerReviewsResponse } from '../models/TListTalentManagerReviewsResponse';
import type { TParseResumeResponse } from '../models/TParseResumeResponse';
import type { TRegisterTalentManagerRequest } from '../models/TRegisterTalentManagerRequest';
import type { TTalentManagerProfileId } from '../models/TTalentManagerProfileId';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TalentManagerService {
    /**
     * List approved Talent Manager profiles
     * @returns TListTalentManagerProfilesResponse Ok
     * @throws ApiError
     */
    public static listTalentManagers(): CancelablePromise<TListTalentManagerProfilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers',
        });
    }
    /**
     * Get the authenticated user's own Talent Manager profile
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static getMyTalentManager(): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/my',
        });
    }
    /**
     * Upload or replace the authenticated Talent Manager's profile photo
     * @param formData
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static uploadMyProfilePhoto(
        formData: {
            photo: Blob;
        },
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/my/photo',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete the authenticated Talent Manager's profile photo
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static deleteMyProfilePhoto(): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/talent-managers/my/photo',
        });
    }
    /**
     * Parse an uploaded resume and generate a suggested bio (does not require an existing profile)
     * @param formData
     * @returns TParseResumeResponse Ok
     * @throws ApiError
     */
    public static parseResume(
        formData: {
            resume: Blob;
        },
    ): CancelablePromise<TParseResumeResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/parse-resume',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Upload or replace the authenticated Talent Manager's resume
     * @param formData
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static uploadMyResume(
        formData: {
            resume: Blob;
        },
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/my/resume',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete the authenticated Talent Manager's resume
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static deleteMyResume(): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/talent-managers/my/resume',
        });
    }
    /**
     * Get a fresh signed URL for a Talent Manager's resume
     * @param id
     * @returns any Ok
     * @throws ApiError
     */
    public static getTalentManagerResumeUrl(
        id: TTalentManagerProfileId,
    ): CancelablePromise<{
        url: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/{id}/resume-url',
            path: {
                'id': id,
            },
        });
    }
    /**
     * List all Talent Manager profiles regardless of status (admin only)
     * @returns TListTalentManagerProfilesResponse Ok
     * @throws ApiError
     */
    public static listAllTalentManagers(): CancelablePromise<TListTalentManagerProfilesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/admin/all',
        });
    }
    /**
     * Get a single Talent Manager profile by ID
     * @param id
     * @param projectId
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static getTalentManager(
        id: TTalentManagerProfileId,
        projectId?: string,
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/{id}',
            path: {
                'id': id,
            },
            query: {
                'project_id': projectId,
            },
        });
    }
    /**
     * Update own Talent Manager profile
     * @param id
     * @param requestBody
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static updateTalentManager(
        id: TTalentManagerProfileId,
        requestBody: Partial_TRegisterTalentManagerRequest_,
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/talent-managers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a fresh signed URL for a Talent Manager's profile photo
     * @param id
     * @returns any Ok
     * @throws ApiError
     */
    public static getTalentManagerPhotoUrl(
        id: TTalentManagerProfileId,
    ): CancelablePromise<{
        url: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/{id}/photo-url',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Register current user as a Talent Manager
     * @param requestBody
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static registerTalentManager(
        requestBody: TRegisterTalentManagerRequest,
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/register',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approve a Talent Manager (admin only)
     * @param id
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static approveTalentManager(
        id: TTalentManagerProfileId,
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/{id}/approve',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Suspend a Talent Manager (admin only)
     * @param id
     * @returns TGetTalentManagerProfileResponse Ok
     * @throws ApiError
     */
    public static suspendTalentManager(
        id: TTalentManagerProfileId,
    ): CancelablePromise<TGetTalentManagerProfileResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/{id}/suspend',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get reviews for a Talent Manager
     * @param id
     * @returns TListTalentManagerReviewsResponse Ok
     * @throws ApiError
     */
    public static getTalentManagerReviews(
        id: TTalentManagerProfileId,
    ): CancelablePromise<TListTalentManagerReviewsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/talent-managers/{id}/reviews',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Submit a review for a Talent Manager
     * @param id
     * @param requestBody
     * @returns TListTalentManagerReviewsResponse Ok
     * @throws ApiError
     */
    public static createTalentManagerReview(
        id: TTalentManagerProfileId,
        requestBody: TCreateTalentManagerReviewRequest,
    ): CancelablePromise<TListTalentManagerReviewsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/talent-managers/{id}/reviews',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
